import React, { useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import { FileHiddenInput } from "hesus-ui-kit";
import {
  TranslationListContainer,
  Title,
  CreateButton,
  ActionContainer,
} from "./Translation.styled";
import PrepareDataTable from "./PrepareDataTable";
import "./Translation.scss";
import { handleApiError } from "@utils/errorHandler";

/**
 * Translations,
 * Path - /translations
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944008228/Company+view+page+-+Sites)
 * @component
 */
const Translations = (props) => {
  const { t } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef();

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  const fetchRecords = () => {
    setLoading(true);
    axios
      .get(`/translations/list`)
      .then((response) => {
        setData(response?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        handleApiError(error);
        setLoading(false);
      });
  };

  const triggerUploadInput = () => {
    fileInputRef.current.click();
  };

  const onFileSelect = (e) => {
    const dataModified = new FormData();
    if (e.target.files.length > 0) {
      for (let i = 0; i < e.target.files.length; i++) {
        const documentObject = e.target.files[i];
        dataModified.append(`documents[${i}]`, documentObject);
      }
      setLoading(true);
      // setIsRefreshList(true);
      axios
        .post(`/translations/upload`, dataModified, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          setIsRefreshList(true);
        })
        .catch((error) => {});
    }
  };

  const refreshTranslation = () => {
    setLoading(true);
    // setIsRefreshList(true);
    axios
      .get(`/translations/refresh`)
      .then(() => {
        setIsRefreshList(true);
      })
      .catch((error) => {});
  };

  return (
    <TranslationListContainer className="translation-list">
      <Title>{t("TRANSLATION")}</Title>
      <ActionContainer>
        <CreateButton onClick={refreshTranslation}>{`${t(
          "REFRESH_TRANSLATION"
        )}`}</CreateButton>
        <CreateButton onClick={triggerUploadInput}>{`${t(
          "UPLOAD_TRANSLATION"
        )}`}</CreateButton>
      </ActionContainer>

      <FileHiddenInput
        type="file"
        id="document"
        inputClass="document-upload-input-field"
        onFileSelect={onFileSelect}
        fileInputRef={fileInputRef}
      />
      <PrepareDataTable
        isRefreshList={isRefreshList}
        loading={loading}
        data={data}
        setData={setData}
        fetchRecords={fetchRecords}
      />
    </TranslationListContainer>
  );
};

Translations.propTypes = {
  t: PropTypes.func.isRequired,
};

// Translations.defaultProps = {
// };
export default withTranslation()(Translations);
